import {
  FiShoppingBag,
  FiTruck,
  FiMessageCircle,
  FiShield,
  FiArrowRight,
  FiInstagram,
  FiStar,
} from 'react-icons/fi';

/* ─── Injected CSS ─────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,700&display=swap');

/* Hero */
.trimi-hero-section {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #0a1220;
}
.trimi-hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
  transition: transform 0.9s ease;
  will-change: transform;
}
.trimi-hero-section:hover .trimi-hero-img {
  transform: scale(1.03);
}

/* Buttons */
.trimi-btn-primary {
  display: inline-flex; align-items: center; gap: 8px;
  background: #fff; color: #0c1525;
  border: none; border-radius: 999px;
  padding: 15px 32px; font-size: 14px; font-weight: 800;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: transform .25s ease, box-shadow .25s ease, background .2s ease;
  will-change: transform;
  white-space: nowrap;
}
.trimi-btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 36px rgba(0,0,0,0.32);
  background: #f0f6ff;
}

.trimi-btn-ghost {
  display: inline-flex; align-items: center; gap: 8px;
  background: transparent; color: #fff;
  border: 1.5px solid rgba(255,255,255,0.35); border-radius: 999px;
  padding: 14px 28px; font-size: 14px; font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background .25s ease, border-color .25s ease, transform .25s ease;
  will-change: transform;
  white-space: nowrap;
}
.trimi-btn-ghost:hover {
  background: rgba(255,255,255,0.12);
  border-color: rgba(255,255,255,0.7);
  transform: translateY(-2px);
}

.trimi-btn-accent {
  display: inline-flex; align-items: center; gap: 8px;
  background: #2f80ed; color: #fff;
  border: none; border-radius: 999px;
  padding: 14px 28px; font-size: 14px; font-weight: 800;
  cursor: pointer;
  transition: transform .25s ease, box-shadow .25s ease, background .2s ease;
  will-change: transform;
}
.trimi-btn-accent:hover {
  transform: translateY(-3px);
  background: #1a66cc;
  box-shadow: 0 12px 28px rgba(47,128,237,0.38);
}

.trimi-btn-outline {
  display: inline-flex; align-items: center; gap: 8px;
  background: transparent;
  border-radius: 999px;
  padding: 13px 22px; font-size: 14px; font-weight: 700;
  cursor: pointer;
  transition: background .2s ease, transform .2s ease;
  will-change: transform;
}
.trimi-btn-outline:hover { transform: translateY(-2px); }

/* Service cards */
.trimi-service-card {
  border-radius: 20px; padding: 22px 20px;
  display: flex; align-items: center; gap: 16px;
  transition: transform .25s ease, box-shadow .25s ease;
  will-change: transform;
}
.trimi-service-card:hover {
  transform: translateY(-6px);
}

/* Product cards */
.trimi-product-card {
  border-radius: 20px; overflow: hidden; cursor: pointer;
  transition: transform .28s ease, box-shadow .28s ease;
  will-change: transform;
}
.trimi-product-card:hover { transform: translateY(-9px); }
.trimi-product-img {
  width: 100%; height: 100%; object-fit: cover; display: block;
  transition: transform .45s ease;
  will-change: transform;
}
.trimi-product-card:hover .trimi-product-img { transform: scale(1.07); }

/* Category buttons */
.trimi-cat-btn {
  border-radius: 16px; padding: 14px 16px; text-align: left;
  font-size: 14px; font-weight: 700; cursor: pointer;
  display: flex; align-items: center; justify-content: space-between;
  transition: border-color .22s ease, transform .22s ease, background .22s ease;
  will-change: transform;
}
.trimi-cat-btn:hover { transform: translateX(5px); }

/* Promo cards */
.trimi-promo-card {
  border-radius: 24px; overflow: hidden;
  transition: transform .3s ease, box-shadow .3s ease;
  will-change: transform;
}
.trimi-promo-card:hover { transform: translateY(-6px); }

@media (max-width: 768px) {
  .trimi-hero-section { min-height: 85svh !important; }
  .trimi-hero-cta { flex-direction: column; align-items: flex-start; }
  .trimi-hero-cta button { width: 100%; justify-content: center; }
}
`;

function injectCSS(id, css) {
  if (typeof document !== 'undefined' && !document.getElementById(id)) {
    const el = document.createElement('style');
    el.id = id;
    el.textContent = css;
    document.head.appendChild(el);
  }
}

export default function HomeView({ isDarkMode, navigateTo, localProducts }) {
  injectCSS('trimi-home-css', CSS);

  const products = Array.isArray(localProducts) ? localProducts : [];
  const newArrivals = products.slice(0, 8);

  const categories = [
    { label: 'Áo Thun — Form chuẩn, vải cotton mềm', key: 'shirt_1' },
    { label: 'Áo Sơ Mi — Nhẹ, thoáng, dễ phối', key: 'shirt_2' },
    { label: 'Áo Khoác — Ấm nhẹ, phong cách thu đông', key: 'shirt_3' },
    { label: 'Quần Jeans — Co giãn 4 chiều, bền màu', key: 'pants_1' },
  ];

  const services = [
    { icon: <FiShoppingBag />, title: 'Dễ mua sắm', desc: 'Giao diện gọn, chọn đồ nhanh' },
    { icon: <FiTruck />, title: 'Giao hàng nhanh', desc: 'Nội thành Đà Nẵng linh hoạt' },
    { icon: <FiMessageCircle />, title: 'Tư vấn mix đồ', desc: 'Theo phong cách và vóc dáng bạn' },
    { icon: <FiShield />, title: 'Thanh toán an toàn', desc: 'Bảo mật, nhiều hình thức' },
  ];

  const stats = [
    { label: 'Chất liệu', value: 'Premium' },
    { label: 'Phong cách', value: 'Minimalist' },
    { label: 'Form dáng', value: 'Chuẩn Âu' },
    { label: 'Màu sắc', value: 'Trung tính' },
  ];

  const formatPrice = (price) => `${(Number(price) || 0).toLocaleString('vi-VN')} đ`;

  const bg         = isDarkMode ? '#080e1a' : '#f4f7fc';
  const surface    = isDarkMode ? '#0f1824' : '#ffffff';
  const surfaceSoft= isDarkMode ? '#16202e' : '#edf2fb';
  const border     = isDarkMode ? 'rgba(255,255,255,0.07)' : '#e2e9f5';
  const borderHover= '#2f80ed';
  const textPrimary= isDarkMode ? '#f1f5fc' : '#0c1525';
  const textMuted  = isDarkMode ? '#8aa0be' : '#5a7090';
  const accent     = '#2f80ed';
  const accentDeep = '#1a4fa0';

  return (
    <div style={{ background: bg, color: textPrimary, minHeight: '100vh', fontFamily: "'Inter', sans-serif" }}>

      {/* ── HERO ─── full-width cinematic banner ─────────────── */}
      <section
        className="trimi-hero-section"
        style={{ minHeight: '100vh' }}
      >
        {/* Background image */}
        <img
          className="trimi-hero-img"
          src="/cover-trimi.jpg"
          alt="TRIMI cover"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
          }}
          onError={(e) => { e.currentTarget.src = '/1.jpg'; }}
        />

        {/* Gradient overlay — left dark for text, right lighter to show model */}
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(100deg, rgba(6,12,26,0.92) 0%, rgba(6,12,26,0.65) 45%, rgba(6,12,26,0.25) 100%)',
          zIndex: 1,
        }} />

        {/* ── Hero content ── */}
        <div style={{
          position: 'absolute',
          inset: 0,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          padding: '0 clamp(20px, 5vw, 80px)',
        }}>
          <div style={{ color: '#fff', maxWidth: 580 }}>
            {/* Brand name */}
            <div style={{
              fontSize: 'clamp(0.7rem, 1.2vw, 0.85rem)',
              fontWeight: 800,
              letterSpacing: '0.28em',
              color: 'rgba(255,255,255,0.55)',
              marginBottom: 16,
              textTransform: 'uppercase',
            }}>
              Thời Trang Nam — Đà Nẵng
            </div>

            <h1 style={{
              margin: 0,
              fontSize: 'clamp(2.6rem, 6vw, 5.5rem)',
              lineHeight: 0.95,
              fontWeight: 900,
              letterSpacing: '-0.04em',
            }}>
              TRIMI
            </h1>

            <p style={{
              margin: '18px 0 0',
              fontSize: 'clamp(1.05rem, 2.2vw, 1.35rem)',
              fontWeight: 700,
              fontStyle: 'italic',
              color: 'rgba(255,255,255,0.88)',
              letterSpacing: '-0.01em',
            }}>
              Dám Khác Biệt — Dám TRIMI
            </p>

            <p style={{
              margin: '12px 0 0',
              fontSize: 'clamp(0.85rem, 1.4vw, 1rem)',
              color: 'rgba(255,255,255,0.60)',
              fontWeight: 500,
              lineHeight: 1.65,
              maxWidth: 400,
            }}>
              Vải premium · Form chuẩn Âu · Phong cách tối giản
            </p>

            {/* CTAs */}
            <div
              className="trimi-hero-cta"
              style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 36 }}
            >
              <button className="trimi-btn-primary" onClick={() => navigateTo('shop', 'all')}>
                Khám phá ngay <FiArrowRight />
              </button>
              <button className="trimi-btn-ghost" onClick={() => navigateTo('shop', 'shirt_all')}>
                Xem bộ sưu tập
              </button>
            </div>
          </div>
        </div>

        {/* ── Season chip — bottom right ── */}
        <div style={{
          position: 'absolute',
          right: 'clamp(16px, 3vw, 40px)',
          bottom: 'clamp(16px, 3vw, 36px)',
          zIndex: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 6,
        }}>
          <div style={{
            fontSize: 'clamp(9px, 1vw, 11px)',
            fontWeight: 800,
            letterSpacing: '0.22em',
            color: 'rgba(255,255,255,0.5)',
            textTransform: 'uppercase',
          }}>
            Bộ Sưu Tập
          </div>
          <div style={{
            fontSize: 'clamp(1rem, 2vw, 1.4rem)',
            fontWeight: 900,
            color: '#fff',
            letterSpacing: '-0.02em',
          }}>
            Xuân Hè 2026
          </div>
        </div>
      </section>

      {/* ── SERVICES ──────────────────────────────────────── */}
      <section style={{ padding: 'clamp(24px,4vw,40px) clamp(16px,3vw,32px) 0' }}>
        <div style={{
          maxWidth: 1280, margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 14,
        }}>
          {services.map((item) => (
            <div
              key={item.title}
              className="trimi-service-card"
              style={{
                background: surface,
                border: `1px solid ${border}`,
                boxShadow: isDarkMode ? 'none' : '0 2px 14px rgba(12,21,37,0.05)',
              }}
            >
              <div style={{
                width: 48, height: 48, borderRadius: 14, flexShrink: 0,
                background: isDarkMode ? 'rgba(47,128,237,0.14)' : '#e8f1ff',
                color: accent,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22,
              }}>
                {item.icon}
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 800, color: textPrimary }}>{item.title}</div>
                <div style={{ fontSize: 12.5, color: textMuted, marginTop: 3 }}>{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── STYLE / COLLECTION SPLIT ──────────────────────── */}
      <section style={{ padding: 'clamp(28px,4vw,44px) clamp(16px,3vw,32px) 0' }}>
        <div style={{
          maxWidth: 1280, margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 22,
        }}>
          {/* Left — editorial image */}
          <div
            className="trimi-promo-card"
            style={{
              position: 'relative',
              minHeight: 500,
              border: `1px solid ${border}`,
              background: surface,
            }}
          >
            <img
              src={products[1]?.imageUrl || '/2.jpg'}
              alt="TRIMI lookbook"
              style={{
                width: '100%', height: '100%',
                position: 'absolute', inset: 0,
                objectFit: 'cover',
                transition: 'transform 0.5s ease',
              }}
              onError={(e) => { e.currentTarget.src = '/2.jpg'; }}
            />
            <div style={{
              position: 'absolute', inset: 0,
              background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.72) 100%)',
            }} />
            <div style={{ position: 'absolute', left: 28, right: 28, bottom: 28, color: '#fff' }}>
              <div style={{
                display: 'inline-block', padding: '5px 12px', borderRadius: 999,
                background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)',
                fontSize: 10, fontWeight: 800, letterSpacing: '0.18em', marginBottom: 12,
              }}>
                TRIMI LOOKBOOK
              </div>
              <div style={{ fontSize: 'clamp(1.3rem,2.5vw,1.75rem)', fontWeight: 900, lineHeight: 1.2 }}>
                Tối giản,<br />vẫn có điểm nhấn.
              </div>
            </div>
          </div>

          {/* Right — collection info */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            {/* Collection card */}
            <div style={{
              background: surface, border: `1px solid ${border}`,
              borderRadius: 24, padding: 'clamp(22px,3vw,32px)',
              boxShadow: isDarkMode ? 'none' : '0 4px 20px rgba(12,21,37,0.06)',
              flex: 1,
            }}>
              <div style={{
                display: 'inline-block', padding: '6px 14px', borderRadius: 999,
                background: isDarkMode ? 'rgba(47,128,237,0.16)' : '#e8f1ff',
                color: accent, fontSize: 11, fontWeight: 800, letterSpacing: '0.16em',
                marginBottom: 18,
              }}>
                BỘ SƯU TẬP 2026
              </div>

              <h2 style={{
                margin: 0,
                fontSize: 'clamp(1.7rem, 2.6vw, 2.4rem)',
                fontWeight: 900, lineHeight: 1.1, letterSpacing: '-0.03em',
              }}>
                Mặc đẹp mỗi ngày,<br />
                <span style={{ color: accent }}>không cần cố gắng.</span>
              </h2>

              <p style={{
                marginTop: 14, marginBottom: 24,
                color: textMuted, fontSize: 14, lineHeight: 1.8,
              }}>
                Bộ sưu tập TRIMI — thiết kế tinh gọn, chất liệu thở được,
                form dáng tôn vóc dáng mọi người mặc.
              </p>

              <div style={{ display: 'grid', gap: 10 }}>
                {categories.map((item) => (
                  <button
                    key={item.key}
                    className="trimi-cat-btn"
                    onClick={() => navigateTo('shop', item.key)}
                    style={{
                      background: surfaceSoft,
                      color: textPrimary,
                      border: `1.5px solid ${border}`,
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = borderHover; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = border; }}
                  >
                    {item.label}
                    <FiArrowRight style={{ flexShrink: 0, opacity: 0.55 }} />
                  </button>
                ))}
              </div>

              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 24 }}>
                <button className="trimi-btn-accent" onClick={() => navigateTo('shop', 'all')}>
                  Xem tất cả <FiArrowRight />
                </button>
                <button
                  className="trimi-btn-outline"
                  onClick={() => navigateTo('shop', 'acc_all')}
                  style={{ color: textPrimary, border: `1.5px solid ${border}` }}
                >
                  <FiInstagram /> Theo dõi TRIMI
                </button>
              </div>
            </div>

            {/* Stats grid */}
            <div style={{
              background: surface, border: `1px solid ${border}`,
              borderRadius: 24, padding: 20,
              display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12,
              boxShadow: isDarkMode ? 'none' : '0 4px 20px rgba(12,21,37,0.06)',
            }}>
              {stats.map((s) => (
                <div key={s.label} style={{
                  background: surfaceSoft, borderRadius: 16, padding: '16px 18px',
                  border: `1px solid ${border}`,
                }}>
                  <div style={{ fontSize: 10, color: textMuted, fontWeight: 700, letterSpacing: '0.1em' }}>
                    {s.label.toUpperCase()}
                  </div>
                  <div style={{ fontSize: 18, fontWeight: 900, marginTop: 6, color: textPrimary }}>
                    {s.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── PRODUCTS ──────────────────────────────────────── */}
      {newArrivals.length > 0 && (
        <section style={{ padding: 'clamp(32px,4vw,52px) clamp(16px,3vw,32px) clamp(40px,5vw,72px)' }}>
          <div style={{ maxWidth: 1280, margin: '0 auto' }}>
            {/* section header */}
            <div style={{
              display: 'flex', alignItems: 'flex-end',
              justifyContent: 'space-between', gap: 16,
              flexWrap: 'wrap', marginBottom: 26,
            }}>
              <div>
                <div style={{
                  fontSize: 11, color: textMuted, fontWeight: 800,
                  letterSpacing: '0.2em', marginBottom: 8,
                }}>
                  SẢN PHẨM NỔI BẬT
                </div>
                <h2 style={{
                  margin: 0,
                  fontSize: 'clamp(1.7rem, 3vw, 2.4rem)',
                  fontWeight: 900, letterSpacing: '-0.03em',
                }}>
                  Được yêu thích nhất
                </h2>
              </div>
              <button
                className="trimi-btn-outline"
                onClick={() => navigateTo('shop', 'all')}
                style={{
                  color: textPrimary,
                  border: `1.5px solid ${border}`,
                  background: surface,
                  padding: '12px 22px',
                }}
              >
                Xem tất cả <FiArrowRight />
              </button>
            </div>

            {/* product grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: 18,
            }}>
              {newArrivals.map((product, index) => (
                <div
                  key={product.id || index}
                  className="trimi-product-card"
                  onClick={() => navigateTo('productDetail', product.category || 'all', product)}
                  style={{
                    background: surface,
                    border: `1px solid ${border}`,
                    boxShadow: isDarkMode ? 'none' : '0 2px 14px rgba(12,21,37,0.06)',
                  }}
                >
                  {/* image */}
                  <div style={{
                    position: 'relative',
                    background: surfaceSoft,
                    aspectRatio: '4 / 5',
                    overflow: 'hidden',
                  }}>
                    <img
                      className="trimi-product-img"
                      src={product.imageUrl}
                      alt={product.name}
                    />
                    {/* brand badge */}
                    <div style={{
                      position: 'absolute', top: 12, left: 12,
                      background: 'rgba(255,255,255,0.93)',
                      color: accentDeep,
                      padding: '5px 10px', borderRadius: 999,
                      fontSize: 10, fontWeight: 800, letterSpacing: '0.08em',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                    }}>
                      TRIMI
                    </div>
                    {/* rating */}
                    <div style={{
                      position: 'absolute', top: 12, right: 12,
                      background: 'rgba(255,255,255,0.93)',
                      color: '#f59e0b',
                      padding: '5px 9px', borderRadius: 999,
                      fontSize: 11, fontWeight: 800,
                      display: 'flex', alignItems: 'center', gap: 4,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
                    }}>
                      <FiStar /> 4.9
                    </div>
                  </div>

                  {/* info */}
                  <div style={{ padding: '14px 16px 18px' }}>
                    <h3 style={{
                      margin: 0, fontSize: 14, fontWeight: 700,
                      lineHeight: 1.5, color: textPrimary,
                      display: '-webkit-box',
                      WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                      overflow: 'hidden', minHeight: 42,
                    }}>
                      {product.name}
                    </h3>
                    <div style={{
                      marginTop: 10, fontSize: 16,
                      fontWeight: 900, color: accent,
                    }}>
                      {formatPrice(product.price)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}